import { AUTH_USER_TYPES } from "../types";
import ApiService from "../../common/apiService";
import { getData } from "../../common/dataHelper";
const state = {
    user: {},
};

const getters = {
    [AUTH_USER_TYPES.GET_USER](state) {
        return state.user;
    },
};

const actions = {
    async [AUTH_USER_TYPES.FETCH_USER]({ commit }) {
        const response = await ApiService.query("academy/customer");
        const user = getData(response, "data.customer");
        if (user) {
            commit(AUTH_USER_TYPES.SET_USER, user);
        }
        return response;
    },
    async [AUTH_USER_TYPES.UPDATE_USER]({ commit }, { user }) {
        if (getData(user, "avatar.id") == null) {
            delete user.avatar;
        }
        const response = await ApiService.put("academy/customer", user);

        const newUser = getData(response, "data.customer");
        if (newUser) {
            commit(AUTH_USER_TYPES.SET_USER, newUser);
        }
        return response;
    },
    async [AUTH_USER_TYPES.CHANGE_USER_PASSWORD](ctx, { user }) {
        if (getData(user, "avatar.id") == null) {
            delete user.avatar;
        }
        const response = await ApiService.put("academy/passwordReset", user);

        return response;
    },
};

const mutations = {
    [AUTH_USER_TYPES.SET_USER](state, object) {
        state.user = object;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
